import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/news.png'


const _withScopeId = n => (_pushScopeId("data-v-3c3710a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "news-list-img"
  })
], -1))
const _hoisted_2 = { class: "news-list-news-page-main" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_News = _resolveComponent("News")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_Bottom = _resolveComponent("Bottom")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Header, { titleId: 3 }),
    _hoisted_1,
    _createVNode(_component_News, {
      titleFlag: false,
      newsList: _ctx.newsList
    }, null, 8, ["newsList"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_pagination, {
        onCurrentChange: _ctx.handleCurrentChange,
        "current-page": _ctx.page,
        layout: "prev, pager, next",
        "prev-text": "上一页",
        "next-text": "下一页",
        background: "",
        total: _ctx.total,
        "page-size": _ctx.limit,
        class: "news-list-news-page"
      }, null, 8, ["onCurrentChange", "current-page", "total", "page-size"])
    ]),
    _createVNode(_component_Bottom)
  ]))
}